




































































































































import { Component, Vue, Ref } from "vue-property-decorator";
import sidebar from "@/components/englishjanala/sidebar.vue";
import Sentences from "@/components/cards/Sentences.vue";
import NewSection from "@/components/modals/NewGrammarSection.vue";
import ConversationIcon from "@/components/svgicon/ConversationSVG.vue";
import WordsIcon from "@/components/svgicon/WordsSVG.vue";
import GrammarIcon from "@/components/svgicon/GrammarSVG.vue";
import HeadphonSVG from "@/components/svgicon/HeadphonSVG.vue";
import Sections from "@/components/cards/GrammarSections.vue";
import { Dialog, Notify } from "vant";
import axios from "axios";
import Spiner from "@/components/englishjanala/Spiner.vue";

// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditor from "ckeditor4-vue";
// import { VueEditor } from "vue2-editor";
// import { Chapter } from "@/model/englishjanala/englishjanala.ts";
import * as data from "@/model/englishjanala/englishjanala.json";
/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */
Vue.use(CKEditor);
@Component({
  components: {
    Sentences,
    sidebar,
    NewSection,
    CKEditor,
    Sections,
    Spiner,
  },
})
export default class GrammarChapter extends Vue {
  Spiner: boolean = true;
  ConvId: any;
  Sections: any;
  chap: any;
  TextChange = "";
  DivId = -1;
  Edit = false;
  show = false;
  hover: boolean = false;
  whoEn = "";
  sentenceEn = "";
  whoBn = "";
  sentenceBn = "";
  Chapter: any = null;
  errors: any = [];
  category: any = null;
  ShowEditInput() {
    // Edit = true;
    this.Edit = true;
  }
  editorConfig: {
    height: "100%";
  };

  UpdateChapter() {
    const catId = this.$route.params.CategoryId;
    const passData = { category_id: catId, chapter: this.Chapter.chapter };

    const response = axios
      .post(
        "https://api.englishjanala.com:8443/v1/englishjanala/grammar/GrammarService/UpdateGrammarChapter",
        passData
      )
      .then()
      .catch((error) => {
        Notify({ type: "danger", message: "Grammar Chapter is not Updated" });
      });
    console.warn("rs", response);
    Notify({ type: "success", message: "Grammar Chapter Updated" });
    // const x = 10;
  }
  //
  async mounted() {
    const catId = this.$route.params.CategoryId;
    const chapId = this.$route.params.ChapterId;
    const ides = { category_id: catId, chapter_id: chapId };

    const response = await axios.post(
      "https://api.englishjanala.com:8443/v1/englishjanala/grammar/GrammarService/GetGrammarChapter",
      ides
    );
    const data = response.data;
    console.warn("Sections ", data.chapter.chapterSections);
    this.Chapter = data;
    console.warn("data ", data);
    this.Spiner = false;
  }

  get CategoryId() {
    this.ConvId = this.$route.params.CategoryId;
    return this.$route.params.CategoryId;
  }
  get ChapterId() {
    return this.$route.params.ChapterId;
  }

  get Conversation() {
    return data.conversationCategories.filter((item) => {
      return item.id == this.CategoryId;
    });
  }
  getImgUrl(item: any) {
    return item.imageUrl;
  }
}
